import React from "react";
import { Table, Skeleton } from "antd";
import Column from "antd/es/table/Column";

import NoDataIcon from "../../../assets/svg/no-data.svg";
import { useTranslation } from "react-i18next";

const ConstituencyDataTable = ({
  isDataAvailable,
  data,
  constituencyLoading,
  constituencyDataType
}) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const themes = localStorage.getItem("themes");
  
  return (
    <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] hover:scale-[1.01] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50 max-h-[420px]">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
        <div 
          className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      <h1 className="modern-table-title text-lg font-bold text-black mb-2 relative z-10">
        {constituencyDataType === 'state' && t("Assembly Form 20 Data")} 
        {constituencyDataType === 'central' && t("Parliamentary Form 20 Data")} 
      </h1>

      {isDataAvailable ? (
        <div className="modern-table-wrapper relative z-10">
          <Table
            className="modern-glass-table"
            style={{boxSizing: "border-box"}}
            rowKey={(record) => record.type}
            scroll={{ x: "max-content" }}
            dataSource={data}
            pagination={false}
            locale={{
              emptyText:
                constituencyLoading || !data ? (
                  <div className="loading-container">
                    <Skeleton
                      title={false}
                      active
                      paragraph={{
                        rows: 5,
                        width: ["100%", "100%", "100%", "100%", "100%"],
                        height: ["30px", "30px", "30px", "30px", "30px"]
                      }}
                    />
                  </div>
                ) : (
                  <div className='no-data-icon mt-20'>
                    <img src={NoDataIcon} alt='' />
                    <h1>{t("No Data Available")}</h1>
                  </div>
                )
            }}
          >
          <Column
            title='Party'
            dataIndex='partyName'
            render={(text, record) => {
              let color = record.partyColorCode;

              if (text === "total") {
                color = themes === 'darkMode' ? "#fff" : record.partyColorCode;
              } else if (text === "others") {
                color = themes === 'darkMode' ? "#D3D3D3" : record.partyColorCode;
              }

              return (
                <span
                  style={{
                    fontWeight: "bold",
                    color: color
                  }}
                >
                  {text}
                </span>
              );
            }}
          />

          <Column
            title='Vote Share'
            dataIndex='voteShare'
            render={(text) => (
              <div style={{ textAlign: "center", color: "#000000", fontWeight: "500" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Vote Share%'
            dataIndex='voteSharePercentage'
            render={(text) => (
              <div style={{ textAlign: "center", color: "#000000", fontWeight: "500" }}>
                {text !== null && text !== undefined
                  ? `${parseFloat(text).toFixed(2)}%`
                  : "-"}
              </div>
            )}
          />

          <Column
            // title={constituencyDataType==='central'?'Assemblies':'Villages'}
            title={constituencyDataType==='central'?'Assemblies':(user?.urbanRural==='Urban' ? t("Wards") :t("Villages"))}
            dataIndex='noOfVillageWon'
            render={(text) => (
              <div style={{ textAlign: "center", color: "#000000", fontWeight: "500" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Polling Station'
            dataIndex='noOfPSWon'
            render={(text) => (
              <div style={{ textAlign: "center", color: "#000000", fontWeight: "500" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />
        </Table>
        </div>
      ) : (
        <div className='no-data-icon mt-20'>
          <img src={NoDataIcon} alt='' />
          <h1>{t("No Data Available")}</h1>
        </div>
      )}
    </div>
  );
};

export default ConstituencyDataTable;
